(() => {
    window.Alpine.start();
})();
